<template>
    <div
        class="pos-relative border-radius overflow-hidden cursor-pointer"
        @click="$emit('show-zoom')"
    >
        <div class="aspect pos-relative bg-default-1" style="padding-bottom: 177.77%">
            <div class="pos-absolute pos-all">
                <img
                    :data-src="imageSource"
                    class="w-full h-full lazy lazy-fade"
                    style="object-fit: cover"
                />
            </div>
            <div
                class="hidden-md-up pos-absolute pos-bottom bg-info-4 text-white text-center text-yanone text-bold h5"
                style="
                    width: 22%;
                    margin-left: 1rem;
                    margin-bottom: 1.2rem;
                    padding-top: 0.4rem;
                    padding-bottom: 0.4rem;
                "
            >
                {{ sizes[image.size_id].name }}
            </div>
            <div
                class="hidden-md-down pos-absolute pos-bottom bg-info-4 text-white text-center text-yanone text-bold h5"
                style="
                    width: 22%;
                    margin-left: 1rem;
                    margin-bottom: 1.2rem;
                    padding-top: 0.4rem;
                    padding-bottom: 0.4rem;
                "
            >
                {{ sizes[image.size_id].name }}
            </div>
        </div>

        <span class="pos-absolute pos-right pos-top mt mr h5">
            <i class="icon-cr icon-zoom-in" />
        </span>
    </div>
</template>

<script>
    import { updateLazyLoad } from '../../../../../submodules/src/script/lazyload';

    export default {
        name: 'SizeGuideImageV2',

        props: {
            image: {
                type: Object,
                required: true,
            },
            productTypeId: {
                type: Number,
                required: true,
            },
            sizes: {
                Object,
                required: true,
            },
        },

        mounted() {
            this.$nextTick(() => {
                updateLazyLoad();
            });
        },

        computed: {
            imageSource() {
                return `${this.$scope.CDN_IMAGES}/images/site/guia-de-tamanhos/${
                    this.productTypeId
                }/${this.sizes[this.image.size_id].name}/${
                    this.image.url
                }?auto=compress,format&q=65&w=400`;
            },
        },
    };
</script>
